import { render } from "./BasePromoSlides.vue?vue&type=template&id=9709d306&scoped=true"
import script from "./BasePromoSlides.vue?vue&type=script&lang=js"
export * from "./BasePromoSlides.vue?vue&type=script&lang=js"

import "./BasePromoSlides.vue?vue&type=style&index=0&id=9709d306&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9709d306"]])

export default __exports__